//
// GraphElement.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./VisualElement";
import "@sas-dvr/ltjs-gtl/models/Graph";
import "../dataDefinition/DataDefinition";
import "./GeoViewport";
import "./GraphContent";

var GraphElement = createModule("BIRD::GraphElement", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::VisualElement"], EventDispatcher, [
    ,
    {
        graphType: 7,
        graphContent: 1,
        graphSubType: 7,
        statgraphXML: 7,
        primaryDataDefinition: 1,
        mapDataDefinition: 1,
        statgraph: 1,
        geoViewport: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default GraphElement;
